import { Component, OnInit } from '@angular/core';
import { I18nService } from 'src/app/modules/i18n/i18n.service';
import { environment } from 'src/environments/environment';
import * as _moment from 'moment';
const moment = _moment;
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { VideoDialogComponent } from './components/video-dialog/video-dialog.component';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexCompnent implements OnInit {
  slideConfig = {
    autoplay: true, "slidesToShow": 3, "slidesToScroll": 1,
    responsive: [
      {breakpoint: 1366, settings: { slidesToShow: 2 }},
      {breakpoint: 980, settings: { slidesToShow: 1 }},
    ]
    };
  urls = environment.AppRedirectUrls;
  innerWidth: any;
  demoVideos = [
    {
    title: 'Self Registration',
    url: 'https://prod-cdn.preprod.co-vin.in/sandbox/assets/videos/Self-registration.mp4',
  },
  {
    title: 'Vaccinator',
    url: 'https://prod-cdn.preprod.co-vin.in/sandbox/assets/videos/Starting-session-and-Vaccination.mp4',
  },
  {
    title: 'Session Creation',
    url: 'https://prod-cdn.preprod.co-vin.in/sandbox/assets/videos/Admin%20Session%20creation.mp4',
  }
  // {
  //   title: 'Digital Certificates',
  //   url: ''
  // }
]
  constructor(
    public i18nService: I18nService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
  }

  openDialogVideo(videoObj: Object) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    let relativeWidth = (this.innerWidth * 40) / 100; // take up to 80% of the screen size

    if (this.innerWidth > 1500) {
      relativeWidth = (1500 * 40 ) / 100;
    } else {
      relativeWidth = (this.innerWidth * 40 ) / 100;
    }

    if(this.innerWidth < 780){
       relativeWidth=(this.innerWidth * 80 ) / 100;

    }


    const relativeHeight = (relativeWidth * 9) / 16 + 120; // 16:9 to which we add 120 px for the dialog action buttons ("close")
    dialogConfig.width = relativeWidth + 'px';
    dialogConfig.height = relativeHeight + 'px';

    dialogConfig.data = {
      videoObj
    };

    const dialogRef = this.dialog.open(VideoDialogComponent, dialogConfig);

  }



}
